<template>
    <svg
        class="inline-flex"
        viewBox="0 0 25 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.75 7.858H4.69L3.147 1.792c-.073-.279-.229-.525-.458-.641A6.573 6.573 0 00.8.509V.275h3.318c.458 0 .801.35.859.758l.801 4.376L7.837.275h2.002L6.75 7.858zm4.234 0H9.04L10.641.275h1.945l-1.602 7.583zm4.119-5.482c.057-.409.4-.642.801-.642a3.534 3.534 0 011.888.35L18.136.45A4.801 4.801 0 0016.362.1C14.474.1 13.1 1.15 13.1 2.607c0 1.11.973 1.692 1.66 2.043.743.35 1.03.583.972.933 0 .524-.572.758-1.143.758a4.79 4.79 0 01-2.003-.467l-.343 1.634c.687.29 1.43.408 2.117.408 2.117.058 3.432-.992 3.432-2.567 0-1.983-2.69-2.1-2.69-2.974zM24.6 7.858L23.055.275h-1.659a.862.862 0 00-.801.583l-2.86 7h2.002l.4-1.108h2.46l.23 1.108H24.6zm-2.917-5.54l.571 2.857h-1.602l1.03-2.858z"
            fill="#172B85"
        />
    </svg>
</template>